import {translate} from "../../../../i18n";

export default function getAttributeCheckboxItems(attributeGroup, attributes) {

    const groupAttributes = attributes
        .filter(t => t.group_id === attributeGroup.id)
        .sort((a, b) => a.sort_order - b.sort_order);

    const checkboxItems = [];

    if (attributeGroup.segment_size !== null && attributeGroup.segment_size > 1) {
        for (let i = 0; i < groupAttributes.length; i += attributeGroup.segment_size) {
            const firstIndex = i;
            const lastIndex = Math.min(i + attributeGroup.segment_size - 1, groupAttributes.length - 1);

            const itemName = firstIndex === lastIndex
                ? groupAttributes[firstIndex].name
                : translate(':first - :last', {
                    first: groupAttributes[firstIndex].name,
                    last: groupAttributes[lastIndex].name
                });

            const itemValue = [];
            for (let j = firstIndex; j <= lastIndex; j++) {
                itemValue.push(groupAttributes[j].id);
            }

            checkboxItems.push({
                name: itemName,
                value: itemValue,
            });
        }
    } else {
        groupAttributes.forEach(attr => {
            checkboxItems.push({
                name: attr.name,
                value: [attr.id]
            });
        });
    }

    return checkboxItems;
}
